// extracted by mini-css-extract-plugin
export default {"app":"Promotion_app__X7F+U","box":"Promotion_box__nO+kd","list":"Promotion_list__xYJkl","item":"Promotion_item__igJD4","menuItemActive":"Promotion_menuItemActive__blVKG"};